import { render, staticRenderFns } from "./TktzEdit.vue?vue&type=template&id=3e38d767&scoped=true"
import script from "./TktzEdit.vue?vue&type=script&lang=js"
export * from "./TktzEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e38d767",
  null
  
)

export default component.exports